'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.icAcademy = '<i class="lif">academy</i>';
exports.icAcademyFilled = '<i class="lif">academy_filled</i>';
exports.icAdd = '<i class="lif">add</i>';
exports.icAddList = '<i class="lif">add_list</i>';
exports.icAddRoundedFilled = '<i class="lif">add_rounded_filled</i>';
exports.icAddUser = '<i class="lif">add_user</i>';
exports.icAddUserFilled = '<i class="lif">add_user_filled</i>';
exports.icAds = '<i class="lif">ads</i>';
exports.icAdsFilled = '<i class="lif">ads_filled</i>';
exports.icAdvertisements = '<i class="lif">advertisements</i>';
exports.icAdvertisementsFilled = '<i class="lif">advertisements_filled</i>';
exports.icAlone = '<i class="lif">alone</i>';
exports.icArea = '<i class="lif">area</i>';
exports.icArrowBigDown = '<i class="lif">arrow_big_down</i>';
exports.icArrowBigLeft = '<i class="lif">arrow_big_left</i>';
exports.icArrowBigRight = '<i class="lif">arrow_big_right</i>';
exports.icArrowBigShadowDown = '<i class="lif">arrow_big_shadow_down</i>';
exports.icArrowBigShadowLeft = '<i class="lif">arrow_big_shadow_left</i>';
exports.icArrowBigShadowRight = '<i class="lif">arrow_big_shadow_right</i>';
exports.icArrowBigShadowUp = '<i class="lif">arrow_big_shadow_up</i>';
exports.icArrowBigUp = '<i class="lif">arrow_big_up</i>';
exports.icArrowDown = '<i class="lif">arrow_down</i>';
exports.icArrowLeft = '<i class="lif">arrow_left</i>';
exports.icArrowRight = '<i class="lif">arrow_right</i>';
exports.icArrowSmallDown = '<i class="lif">arrow_small_down</i>';
exports.icArrowSmallLeft = '<i class="lif">arrow_small_left</i>';
exports.icArrowSmallRight = '<i class="lif">arrow_small_right</i>';
exports.icArrowSmallUp = '<i class="lif">arrow_small_up</i>';
exports.icArrowUp = '<i class="lif">arrow_up</i>';
exports.icAttachment = '<i class="lif">attachment</i>';
exports.icBall = '<i class="lif">ball</i>';
exports.icBankSlip = '<i class="lif">bank_slip</i>';
exports.icBathroom = '<i class="lif">bathroom</i>';
exports.icBedroom = '<i class="lif">bedroom</i>';
exports.icBell = '<i class="lif">bell</i>';
exports.icBellFilled = '<i class="lif">bell_filled</i>';
exports.icBellPlus = '<i class="lif">bell_plus</i>';
exports.icBellPlusFilled = '<i class="lif">bell_plus_filled</i>';
exports.icBike = '<i class="lif">bike</i>';
exports.icBills = '<i class="lif">bills</i>';
exports.icBillsFilled = '<i class="lif">bills_filled</i>';
exports.icBlocked = '<i class="lif">blocked</i>';
exports.icBrinquedoteca = '<i class="lif">brinquedoteca</i>';
exports.icBuild = '<i class="lif">build</i>';
exports.icBuildFilled = '<i class="lif">build_filled</i>';
exports.icBuilding = '<i class="lif">building</i>';
exports.icBuildingFilled = '<i class="lif">building_filled</i>';
exports.icCalendar = '<i class="lif">calendar</i>';
exports.icCalendarCheck = '<i class="lif">calendar_check</i>';
exports.icCalendarCheckFilled = '<i class="lif">calendar_check_filled</i>';
exports.icCalendarFilled = '<i class="lif">calendar_filled</i>';
exports.icCamera = '<i class="lif">camera</i>';
exports.icCameraDisabled = '<i class="lif">camera_disabled</i>';
exports.icCameraDisabledFilled = '<i class="lif">camera_disabled_filled</i>';
exports.icCameraFilled = '<i class="lif">camera_filled</i>';
exports.icCameraPlus = '<i class="lif">camera_plus</i>';
exports.icCameraPlusFilled = '<i class="lif">camera_plus_filled</i>';
exports.icCar = '<i class="lif">car</i>';
exports.icChair = '<i class="lif">chair</i>';
exports.icChairFilled = '<i class="lif">chair_filled</i>';
exports.icChat = '<i class="lif">chat</i>';
exports.icChatFilled = '<i class="lif">chat_filled</i>';
exports.icCheck = '<i class="lif">check</i>';
exports.icCheckDoubleSmall = '<i class="lif">check_double_small</i>';
exports.icCheckSingleSmall = '<i class="lif">check_single_small</i>';
exports.icCheckSmall = '<i class="lif">check_small</i>';
exports.icClientFile = '<i class="lif">client_file</i>';
exports.icClientFileFilled = '<i class="lif">client_file_filled</i>';
exports.icClose = '<i class="lif">close</i>';
exports.icCloseSmall = '<i class="lif">close_small</i>';
exports.icComputer = '<i class="lif">computer</i>';
exports.icConfirm = '<i class="lif">confirm</i>';
exports.icConfirmFilled = '<i class="lif">confirm_filled</i>';
exports.icCopy = '<i class="lif">copy</i>';
exports.icCowork = '<i class="lif">cowork</i>';
exports.icCpf = '<i class="lif">cpf</i>';
exports.icCreditCard = '<i class="lif">credit_card</i>';
exports.icCreditCardFilled = '<i class="lif">credit_card_filled</i>';
exports.icCurrentLocation = '<i class="lif">current_location</i>';
exports.icDanger = '<i class="lif">danger</i>';
exports.icDangerFilled = '<i class="lif">danger_filled</i>';
exports.icDashboard = '<i class="lif">dashboard</i>';
exports.icDashboardFilled = '<i class="lif">dashboard_filled</i>';
exports.icDelete = '<i class="lif">delete</i>';
exports.icDeleteFilled = '<i class="lif">delete_filled</i>';
exports.icDocument = '<i class="lif">document</i>';
exports.icDocumentFilled = '<i class="lif">document_filled</i>';
exports.icDownload = '<i class="lif">download</i>';
exports.icDrink = '<i class="lif">drink</i>';
exports.icEdit = '<i class="lif">edit</i>';
exports.icEditFilled = '<i class="lif">edit_filled</i>';
exports.icEditRounded = '<i class="lif">edit_rounded</i>';
exports.icEditRoundedFilled = '<i class="lif">edit_rounded_filled</i>';
exports.icElevator = '<i class="lif">elevator</i>';
exports.icEllipsisVertical = '<i class="lif">ellipsis_vertical</i>';
exports.icEmail = '<i class="lif">email</i>';
exports.icEmailFilled = '<i class="lif">email_filled</i>';
exports.icEngine = '<i class="lif">engine</i>';
exports.icEngineFilled = '<i class="lif">engine_filled</i>';
exports.icExit = '<i class="lif">exit</i>';
exports.icEye = '<i class="lif">eye</i>';
exports.icEyeDisabled = '<i class="lif">eye_disabled</i>';
exports.icEyeDisabledFilled = '<i class="lif">eye_disabled_filled</i>';
exports.icEyeFilled = '<i class="lif">eye_filled</i>';
exports.icFacebook = '<i class="lif">facebook</i>';
exports.icFamily = '<i class="lif">family</i>';
exports.icFilter = '<i class="lif">filter</i>';
exports.icFilter2 = '<i class="lif">filter2</i>';
exports.icFire = '<i class="lif">fire</i>';
exports.icFireFilled = '<i class="lif">fire_filled</i>';
exports.icFlag = '<i class="lif">flag</i>';
exports.icFlagFilled = '<i class="lif">flag_filled</i>';
exports.icFurniture = '<i class="lif">furniture</i>';
exports.icFurnitureFilled = '<i class="lif">furniture_filled</i>';
exports.icGlassMusic = '<i class="lif">glass_music</i>';
exports.icGoogleFilled = '<i class="lif">google_filled</i>';
exports.icGraphIncrease = '<i class="lif">graph_increase</i>';
exports.icGraphTrendingDown = '<i class="lif">graph_trending_down</i>';
exports.icGraphTrendingUp = '<i class="lif">graph_trending_up</i>';
exports.icGrid = '<i class="lif">grid</i>';
exports.icGymFilled = '<i class="lif">gym_filled</i>';
exports.icHeadset = '<i class="lif">headset</i>';
exports.icHeadsetFilled = '<i class="lif">headset_filled</i>';
exports.icHeart = '<i class="lif">heart</i>';
exports.icHeartFilled = '<i class="lif">heart_filled</i>';
exports.icHelp = '<i class="lif">help</i>';
exports.icHelpFilled = '<i class="lif">help_filled</i>';
exports.icHistory = '<i class="lif">history</i>';
exports.icHome = '<i class="lif">home</i>';
exports.icHomeFilled = '<i class="lif">home_filled</i>';
exports.icHour = '<i class="lif">hour</i>';
exports.icHourFilled = '<i class="lif">hour_filled</i>';
exports.icHouseFinance = '<i class="lif">house_finance</i>';
exports.icHouseFinanceFilled = '<i class="lif">house_finance_filled</i>';
exports.icIncrease = '<i class="lif">increase</i>';
exports.icInfo = '<i class="lif">info</i>';
exports.icInfoFilled = '<i class="lif">info_filled</i>';
exports.icInstagram = '<i class="lif">instagram</i>';
exports.icIntegration = '<i class="lif">integration</i>';
exports.icLightbulb = '<i class="lif">lightbulb</i>';
exports.icLightbulbFilled = '<i class="lif">lightbulb_filled</i>';
exports.icLightning = '<i class="lif">lightning</i>';
exports.icLightningFilled = '<i class="lif">lightning_filled</i>';
exports.icLink = '<i class="lif">link</i>';
exports.icLinkedin = '<i class="lif">linkedin</i>';
exports.icList = '<i class="lif">list</i>';
exports.icLock = '<i class="lif">lock</i>';
exports.icLockFilled = '<i class="lif">lock_filled</i>';
exports.icMap = '<i class="lif">map</i>';
exports.icMenuHamburger = '<i class="lif">menu_hamburger</i>';
exports.icMessage = '<i class="lif">message</i>';
exports.icMessageFilled = '<i class="lif">message_filled</i>';
exports.icMic = '<i class="lif">mic</i>';
exports.icMicDisabled = '<i class="lif">mic_disabled</i>';
exports.icMicDisabledFilled = '<i class="lif">mic_disabled_filled</i>';
exports.icMicFilled = '<i class="lif">mic_filled</i>';
exports.icMoney = '<i class="lif">money</i>';
exports.icMoneyFilled = '<i class="lif">money_filled</i>';
exports.icNewTab = '<i class="lif">new_tab</i>';
exports.icOrder = '<i class="lif">order</i>';
exports.icOrderFilled = '<i class="lif">order_filled</i>';
exports.icParking = '<i class="lif">parking</i>';
exports.icPause = '<i class="lif">pause</i>';
exports.icPet = '<i class="lif">pet</i>';
exports.icPetFilled = '<i class="lif">pet_filled</i>';
exports.icPhone = '<i class="lif">phone</i>';
exports.icPhoneFilled = '<i class="lif">phone_filled</i>';
exports.icPhoneMissed = '<i class="lif">phone_missed</i>';
exports.icPhoneMissedFilled = '<i class="lif">phone_missed_filled</i>';
exports.icPhoneRing = '<i class="lif">phone_ring</i>';
exports.icPhoneRingFilled = '<i class="lif">phone_ring_filled</i>';
exports.icPin = '<i class="lif">pin</i>';
exports.icPinDisabled = '<i class="lif">pin_disabled</i>';
exports.icPinDisabledFilled = '<i class="lif">pin_disabled_filled</i>';
exports.icPinFilled = '<i class="lif">pin_filled</i>';
exports.icPinterest = '<i class="lif">pinterest</i>';
exports.icPlay = '<i class="lif">play</i>';
exports.icPool = '<i class="lif">pool</i>';
exports.icRapidMessage = '<i class="lif">rapid_message</i>';
exports.icRapidMessageFilled = '<i class="lif">rapid_message_filled</i>';
exports.icRefresh = '<i class="lif">refresh</i>';
exports.icRemove = '<i class="lif">remove</i>';
exports.icRemoveFilled = '<i class="lif">remove_filled</i>';
exports.icRemoveRoundedFilled = '<i class="lif">remove_rounded_filled</i>';
exports.icReport = '<i class="lif">report</i>';
exports.icReportFilled = '<i class="lif">report_filled</i>';
exports.icRg = '<i class="lif">rg</i>';
exports.icSave = '<i class="lif">save</i>';
exports.icSaveFilled = '<i class="lif">save_filled</i>';
exports.icScale = '<i class="lif">scale</i>';
exports.icSearch = '<i class="lif">search</i>';
exports.icSecurity = '<i class="lif">security</i>';
exports.icSend = '<i class="lif">send</i>';
exports.icSendOutlined = '<i class="lif">send_outlined</i>';
exports.icShareAndroid = '<i class="lif">share_android</i>';
exports.icShareAndroidFilled = '<i class="lif">share_android_filled</i>';
exports.icShareIos = '<i class="lif">share_ios</i>';
exports.icShareWeb = '<i class="lif">share_web</i>';
exports.icShareWebFilled = '<i class="lif">share_web_filled</i>';
exports.icShoppingBag = '<i class="lif">shopping_bag</i>';
exports.icSpotify = '<i class="lif">spotify</i>';
exports.icStar = '<i class="lif">star</i>';
exports.icStarFilled = '<i class="lif">star_filled</i>';
exports.icStore = '<i class="lif">store</i>';
exports.icSubway = '<i class="lif">subway</i>';
exports.icSubwayFilled = '<i class="lif">subway_filled</i>';
exports.icTag = '<i class="lif">tag</i>';
exports.icTagFilled = '<i class="lif">tag_filled</i>';
exports.icTasks = '<i class="lif">tasks</i>';
exports.icTicket = '<i class="lif">ticket</i>';
exports.icTicketFilled = '<i class="lif">ticket_filled</i>';
exports.icTransfer = '<i class="lif">transfer</i>';
exports.icTree = '<i class="lif">tree</i>';
exports.icTrophy = '<i class="lif">trophy</i>';
exports.icTrophyFilled = '<i class="lif">trophy_filled</i>';
exports.icTwitter = '<i class="lif">twitter</i>';
exports.icUser = '<i class="lif">user</i>';
exports.icUserFilled = '<i class="lif">user_filled</i>';
exports.icUsers = '<i class="lif">users</i>';
exports.icUsersFilled = '<i class="lif">users_filled</i>';
exports.icVerified = '<i class="lif">verified</i>';
exports.icVerifiedOutlined = '<i class="lif">verified_outlined</i>';
exports.icVideo = '<i class="lif">video</i>';
exports.icVideoDisabled = '<i class="lif">video_disabled</i>';
exports.icVideoDisabledFilled = '<i class="lif">video_disabled_filled</i>';
exports.icVideoFilled = '<i class="lif">video_filled</i>';
exports.icVideoPlus = '<i class="lif">video_plus</i>';
exports.icVideoPlusFilled = '<i class="lif">video_plus_filled</i>';
exports.icVirtualTour = '<i class="lif">virtual_tour</i>';
exports.icVolumeDown = '<i class="lif">volume_down</i>';
exports.icVolumeDownFilled = '<i class="lif">volume_down_filled</i>';
exports.icVolumeMute = '<i class="lif">volume_mute</i>';
exports.icVolumeMuteOutlined = '<i class="lif">volume_mute_outlined</i>';
exports.icVolumeOff = '<i class="lif">volume_off</i>';
exports.icVolumeOffFilled = '<i class="lif">volume_off_filled</i>';
exports.icVolumeUp = '<i class="lif">volume_up</i>';
exports.icVolumeUpFilled = '<i class="lif">volume_up_filled</i>';
exports.icWarning = '<i class="lif">warning</i>';
exports.icWarningFilled = '<i class="lif">warning_filled</i>';
exports.icWhatsapp = '<i class="lif">whatsapp</i>';
exports.icYoutube = '<i class="lif">youtube</i>';
